import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseBase } from '../models/response-base';
import { Notifications, NotificationsPaged } from '../models/notificacao';

@Injectable({
    providedIn: 'root'
})
export class NotificacaoService {

    URL: string = environment.GATEWAY + 'notification';

    constructor(private http: HttpClient) {
    }

    getListNotification(pessoaGuid: string, page: number, limit: number, type: number): Observable<ResponseBase<NotificationsPaged>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        headers = headers.append('no-loader', 'true');

        let params = new HttpParams();
        params = params.append('page', page.toString());
        params = params.append('limit', limit.toString());
        params = params.append('type', type.toString());
        return this.http.get<ResponseBase<NotificationsPaged>>(`${this.URL}/list/${pessoaGuid}`, { headers, params});
    }

    getDetalNotification(notificaoId: string): Observable<ResponseBase<Notifications>> {
        return this.http.get<ResponseBase<Notifications>>(`${this.URL}/detail/${notificaoId}`);
    }

    setReadNotification(notificaoId: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.put<ResponseBase<any>>(`${this.URL}/read/${notificaoId}`, null, { headers });
    }

    getUnreadNotification(pessoaGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<any>>(`${this.URL}/unread/${pessoaGuid}`, { headers });
    }

    getTypesNotification(tipo: string): Observable<ResponseBase<any>> {
        let params = new HttpParams();
        params = params.append('personType', tipo.toString());
        return this.http.get<ResponseBase<any>>(`${this.URL}/types`, { params });
    }
}
